export default __webpack_public_path__ + "static/map_marker_B-1c27fd95f06ff691ca392c71dfa3e2cd.png";